import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { installAuthInterceptor } from "@/lib/authToken";
import { LanguageProvider } from "@/lib/i18n/LanguageContext";

// Globaler Auth-Hook: hängt ein gespeichertes JWT an axios-Requests (no-op ohne Token).
installAuthInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// PWA: Service Worker registrieren (installierbar/mobil). Fehler sind unkritisch.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
